import React from 'react';
import { Link } from 'gatsby';
import { addTrailingSlash } from '../utils';

const LocalizedLink = ({ to, linkRef = null, ...props }) => {
    const locale = 'zh-hant'; // temporarily hard code the locale, bc we met the locale generation issue
    if (!to) {
        return <span {...props} />;
    }
    const path = locale === 'zh-hant' ? `${to}` : `/${locale}${to}`;
    const trailingPath = addTrailingSlash(path);
    const internal = /^\/(?!\/)/.test(trailingPath);
    if (internal) {
        return <Link ref={linkRef} {...props} to={trailingPath} />;
    }
    return (
        <a href={trailingPath} {...props} />
    );
};

export default LocalizedLink;
